const url = 'subsidiaries';
import { api } from "api";
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const LOADER_SUBSIDIARY = 'LOADER_SUBSIDIARY';
const SET_DATA_SUBSIDIARY = 'SET_DATA_SUBSIDIARY';
const SET_PAGE_SUBSIDIARY = 'SET_PAGE_SUBSIDIARY';
const SET_UPDATE_DATA_SUBSIDIARY ='SET_UPDATE_DATA_SUBSIDIARY';
const SET_BUSCADOR_SUBSIDIARY = 'SET_BUSCADOR_SUBSIDIARY';
const SET_FILTRO_SUBSIDIARY = 'SET_FILTRO_SUBSIDIARY';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_SUBSIDIARY, cargando: true});
    const store = getStore();
    const search = store.subsidiary.buscador;
    const filtro = store.subsidiary.filtro_subsidiary;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_SUBSIDIARY, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_SUBSIDIARY, data});
            dispatch({type: SET_PAGE_SUBSIDIARY, page});
        }
        dispatch({type: LOADER_SUBSIDIARY, cargando: false});
    })
};
const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_SUBSIDIARY, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_SUBSIDIARY, cargando: false});
        if(error.statusCode  === 404){
            dispatch(push('/subsidiarys'))
        }
    }).then((data) => {
        dispatch({type: LOADER_SUBSIDIARY, cargando: false});
        if(data){
            dispatch({type: SET_UPDATE_DATA_SUBSIDIARY, updateData: data});
            dispatch(initializeForm('subsidiary', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.subsidiary.values;
    dispatch({type: LOADER_SUBSIDIARY, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_SUBSIDIARY, cargando: false})
        Swal('Éxito', 'Se ha creado exitosamente.', 'success')
        .then(() => {
            dispatch(push('/subsidiaries'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_SUBSIDIARY, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => { 
        dispatch({type: LOADER_SUBSIDIARY, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.subsidiary.values);
    dispatch({type: LOADER_SUBSIDIARY, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_SUBSIDIARY, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/subsidiaries'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_SUBSIDIARY, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/subsidiaries'));
        }
    })
}

const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_SUBSIDIARY, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_SUBSIDIARY, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
        })
    }).then((data) => {
        dispatch({type: LOADER_SUBSIDIARY, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_SUBSIDIARY, buscador: search});
    dispatch(listar(1));
};
const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_SUBSIDIARY, filtro_subsidiary: filtro});
    dispatch(listar(1));
};
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro
};
export const reducer = {
    [LOADER_SUBSIDIARY]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_SUBSIDIARY]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_SUBSIDIARY]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_SUBSIDIARY]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_SUBSIDIARY]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_SUBSIDIARY]: (state, { filtro_subsidiary }) => {
        return {...state, filtro_subsidiary }
    },
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_subsidiary: null,
    updateData: {},
};
export default handleActions(reducer, initialState)
